import { combineReducers, configureStore } from "@reduxjs/toolkit";

import notifications from "./slices/notifications";
import v1Graph from "./slices/v1Graph";
import v2Graph from "./slices/v2Graph";
import v3Graph from "./slices/v3Graph";
import ui from "./slices/ui";

export default configureStore({
  reducer: combineReducers({
    notifications,
    v1Graph,
    v2Graph,
    v3Graph,
    ui,
  }),
});
